import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedVideoConsult = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_12483_10263)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M13.125 8.7498L17.1089 6.7583C17.2422 6.69165 17.3904 6.66019 17.5394 6.6669C17.6883 6.67361 17.8331 6.71826 17.9599 6.79663C18.0867 6.87499 18.1915 6.98447 18.2641 7.11466C18.3367 7.24486 18.3749 7.39146 18.375 7.54055V13.459C18.3749 13.6081 18.3367 13.7547 18.2641 13.8849C18.1915 14.0151 18.0867 14.1246 17.9599 14.203C17.8331 14.2813 17.6883 14.326 17.5394 14.3327C17.3904 14.3394 17.2422 14.3079 17.1089 14.2413L13.125 12.2498V8.7498Z",
				stroke: "#333333",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M2.625 7C2.625 6.53587 2.80937 6.09075 3.13756 5.76256C3.46575 5.43437 3.91087 5.25 4.375 5.25H11.375C11.8391 5.25 12.2842 5.43437 12.6124 5.76256C12.9406 6.09075 13.125 6.53587 13.125 7V14C13.125 14.4641 12.9406 14.9092 12.6124 15.2374C12.2842 15.5656 11.8391 15.75 11.375 15.75H4.375C3.91087 15.75 3.46575 15.5656 3.13756 15.2374C2.80937 14.9092 2.625 14.4641 2.625 14V7Z",
				stroke: "#333333",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_12483_10263",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 21,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgOutlinedVideoConsult);
const Memo = memo(ForwardRef);
export default Memo;
